var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":50000,"centered":"","color":"#e1e1e1a2"},model:{value:(_vm.openMode),callback:function ($$v) {_vm.openMode=$$v},expression:"openMode"}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"color":"rgba(85, 84, 84, 0.87)","font-weight":"bold"}},[_vm._v("טוען נתונים, נא להמתין...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }